const typ = { t: 'Typ', name: 'typ-nadwozia', hint: { url: '/type/heavy', select: true }}
export default typ